/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import axios from "axios";
import { first, get, isArray, size } from "lodash";
import moment from "moment";
import {
  all,
  call,
  fork,
  put,
  select,
  takeEvery,
  takeLatest
} from "redux-saga/effects";
import { openToast } from "~/components/common/molecules/ToastNotification";
import history from "~/history";
import * as hospitalActions from "~/store/hospital/hospitalActions";
import * as notiAction from "~/store/notifications/notificationsActions";
import * as paymentTypes from "~/store/payment/paymentType";
import * as types from "~/store/totalData/types";
import { huyi } from "~/utils/clog";
import { CSGroupID, SERVICE_TYPE_BOTH, TypeAction } from "~/utils/constants";
import {
  convertDataToMutipleBookings,
  getDataToReserve,
  getRouteFollowPartnerId,
  getStepFollowTreeMap
} from "~/utils/func";
import { getBaseUrl } from "~/utils/getBaseUrl";
import { client } from "~/utils/medproSDK";
import AppId from "~/utils/partner";
import { handleUnAuthorize } from "~/utils/unAuthorize";
import { BOOKING } from "~/utils/urlApi";
import { currentEnv } from "~/configs";
import * as api from "./apis";
import * as bookingAction from "~/store/booking/bookingAction";
import { setHealthIndex, setNoteAssignment } from "~/store/totalData/actions";

const nodeAction = {
  service: {
    typeSelect: types.SELECT_SERVICE,
    typeReset: types.RESET_SELECT_SERVICE,
    url: "/chon-dich-vu"
  },
  subject: {
    typeSelect: types.SELECT_SUBJECT,
    typeReset: types.RESET_SELECT_SUBJECT,
    url: "/chon-chuyen-khoa"
  },
  doctor: {
    typeSelect: types.SELECT_DOCTOR,
    typeReset: types.RESET_SELECT_DOCTOR,
    url: "/chon-bac-si"
  },
  room: {
    typeSelect: types.SELECT_ROOM,
    typeReset: types.RESET_SELECT_ROOM,
    url: "/chon-phong-kham"
  }
};

function* requestIPAddress() {
  try {
    const response = yield call(fetch, "https://api.ipify.org?format=json");
    const data = yield response.json();
    return data.ip;
  } catch (error) {
    console.log(error);
  }
}

// Booking Tree
function* requestBookingTree({
  text,
  partnerId,
  idBooking,
  selectTree,
  isAddNewSchedule
}) {
  try {
    const global = yield select(state => state.global);
    const cskh = yield select(state => state.customerService);
    const platformType = get(global, "device.type");
    const platform = platformType === "desktop" ? "pc" : "web";

    const partnerid = yield select(state => state.totalData.partnerId);
    const cskhtoken = yield select(
      state => state.customerService.selectedPatient.secretKey
    );
    const schedulesSelected = yield select(
      state => state.totalData.schedulesSelected
    );
    const flow = yield select(state => state.totalData.flow);
    const typeAction = yield select(state => state.totalData.typeAction);

    const finalPartnerID = partnerId || partnerid;

    axios.defaults.headers.partnerid = finalPartnerID;

    const payload = {
      treeId: flow.toUpperCase(),
      idBooking
    };

    if (size(schedulesSelected) >= 1) {
      payload.date = moment(schedulesSelected[0].date).format("DDMMYYYY");
    }

    const response = yield client.getBookingTreeDynamic(payload, {
      partnerid: finalPartnerID,
      appid: AppId,
      platform,
      cskhtoken
    });

    const firstNode = get(response, "data.child", []);
    const firstType = get(response, "data.subType");

    if (firstNode.length < 1 && !firstType) {
      huyi({
        name: "Không có phần tử con",
        child: response
      });
    } else {
      if (schedulesSelected.length >= 1) {
        const { child } = response.data;

        const listSelectedById = schedulesSelected?.map(({ subject }) => {
          return subject.id;
        });
        const listSelectedByName = schedulesSelected?.map(({ subject }) => {
          return subject.name;
        });

        const listFilterByDoctor = child?.filter(({ detail }) => {
          return !listSelectedByName?.includes(detail.subject);
        });

        const listFilterbyDate = child?.filter(
          ({ id }) => !listSelectedById?.includes(id)
        );

        response.data.child =
          flow.toUpperCase() === "DATE" ? listFilterbyDate : listFilterByDoctor;
      }

      yield put({
        type: types.GET_BOOKING_TREE_SUCCESS,
        payload: response.data,
        id: finalPartnerID,
        treeId: flow.toUpperCase(),
        isAddNewSchedule
      });

      const stepOne = getStepFollowTreeMap(
        response.data.subType,
        finalPartnerID
      );

      if (isAddNewSchedule) {
        history.push(stepOne);
      }

      if (!text) {
        const firstNode = get(response, "data.child", []);
        const firstType = get(response, "data.subType");
        const isUpdateBooking = typeAction === TypeAction.SuaPhieuKham;

        if (isUpdateBooking && firstType === "service") {
          const findService = firstNode.find(
            item => item.id === get(cskh, "selectedBill.service.id")
          );
          yield put({
            type: nodeAction[firstType].typeSelect,
            payload: findService
          });
        } else if (firstNode.length === 1) {
          if (
            firstType === "service" &&
            firstNode[0].detail.serviceType === "BOTH"
          ) {
            history.push(stepOne);
          } else {
            yield put({
              type: nodeAction[firstType].typeSelect,
              payload: firstNode[0]
            });
          }
        } else {
          history.push(stepOne);
        }
      }
      yield put(hospitalActions.selectHospital(finalPartnerID));
    }
  } catch (error) {
    huyi({ name: "getBookingTreeDynamic", child: error, type: 0 });
  }
}

function* requestBookingTreeWatcher() {
  yield takeLatest(types.GET_BOOKING_TREE, requestBookingTree);
}

//  Sub Booking Tree
function* requestSubBookingTree() {
  try {
    const global = yield select(state => state.global);
    const platformType = get(global, "device.type");
    const platform = platformType === "desktop" ? "pc" : "web";
    const { selectedBill } = yield select(state => state.customerService);
    const serviceId = yield select(state => state.totalData.service.id);
    const doctorId = yield select(state => state.totalData.doctor.id);
    const subjectId = yield select(state => state.totalData.subject.id);
    const roomId = yield select(state => state.totalData.room.id);
    const schedulesSelected = yield select(
      state => state.totalData.schedulesSelected
    );
    const partnerid = yield select(state => state.totalData.partnerId);
    const cskhtoken = yield select(
      state => state.customerService.selectedPatient.secretKey
    );

    const flow = yield select(state => state.totalData.flow);

    const payload = {
      treeId: flow.toUpperCase(),
      serviceId,
      doctorId,
      subjectId,
      roomId,
      idBooking: selectedBill?.id
    };

    if (size(schedulesSelected) > 0) {
      payload.date = moment(schedulesSelected[0].date).format("DDMMYYYY");
    }

    const response = yield client.getBookingTreeCurrentNode(payload, {
      partnerid,
      appid: AppId,
      platform,
      cskhtoken
    });
    const { type } = response.data;
    yield put({ type: types.UPDATE_CURRENT_NODE, node: response.data });
    yield put({ type: nodeAction[type].typeSelect, payload: response.data });
  } catch (error) {
    console.log(error);
  }
}

function* requestSubBookingTreeWatcher() {
  yield takeLatest(types.GET_SUB_BOOKING_TREE, requestSubBookingTree);
}

// Reserve Booking
function* requestReserveBooking({ referralCode }) {
  try {
    const global = yield select(state => state.global);
    const platformType = get(global, "device.type");
    const platform = platformType === "desktop" ? "pc" : "web";

    const token = yield select(state => state.user.info.token);

    const totalDataReducer = yield select(state => state.totalData);
    const globalReducer = yield select(state => state.global);
    const paymentMethodReducer = yield select(state => state.payment);
    const patientReducer = yield select(state => state.patient);
    const reExamReducer = yield select(state => state.followUpExam);
    const bookingReducer = yield select(state => state.booking);

    const { cskhToken } = yield select(state => state.customerService);

    const partnerid = get(totalDataReducer, "partnerId");

    const postData = getDataToReserve(
      totalDataReducer,
      globalReducer,
      paymentMethodReducer,
      patientReducer,
      reExamReducer,
      bookingReducer
    );
    const searchedPhone = yield select(
      state => state.customerService.searchedPhone
    );
    postData.redirectUrl = `${window.location.origin}/cskh/booking`;
    postData.groupId = CSGroupID;

    const healthIndex = get(totalDataReducer, "healthIndex", {});
    if (healthIndex.height && healthIndex.weight) {
      postData.height = Number(healthIndex.height);
      postData.weight = Number(healthIndex.weight);
      delete postData.healthIndex;
    }

    if (referralCode && referralCode.trim() !== "") {
      postData.referralCode = referralCode.trim();
    }

    const noteAssignment = get(totalDataReducer, "noteAssignment", "");
    if (noteAssignment && noteAssignment.trim() !== "") {
      postData.noteAssignment = noteAssignment.trim();
    }

    window.localStorage.setItem("searchedPhone", searchedPhone);
    const response = yield client.reserveBooking(postData, {
      partnerid,
      appid: AppId,
      token,
      platform,
      cskhtoken: cskhToken
    });
    const { data } = response;

    yield put({
      type: types.RESERVE_BOOKING_SUCCESS,
      payload: data
    });

    if (data.transactionId) {
      history.push(`/cskh/booking?mpTransaction=${data.transactionId}`);
    }
  } catch (error) {
    console.log("error requestReserveBooking :>> ", error);
    const { statusCode, message } = get(error, "response.data", "");
    openToast(message, "error");
    if (statusCode === 401) {
      handleUnAuthorize();
    }
    yield put({
      type: types.RESERVE_BOOKING_FAILURE
    });
  } finally {
    yield put(bookingAction.updateBookingSuccess());
    yield put(setHealthIndex({ height: "", weight: "" }));
    yield put(setNoteAssignment(""));
  }
}

function* requestReserveBookingRePayment({ info }) {
  try {
    let paramsVisa;
    const global = yield select(state => state.global);

    const platformType = get(global, "device.type");

    const {
      selectedMethod: { checkEmail, code },
      methodId
    } = yield select(state => state.payment);

    const totalData = yield select(state => state.totalData);
    const bookingId = get(totalData, "paymentInformation[0].bookingInfo.id");
    const ipAddress = yield call(requestIPAddress);
    if (checkEmail) {
      paramsVisa = {
        customerIpAddress: ipAddress,
        browserScreenHeight: window.innerHeight,
        browserScreenWidth: window.innerWidth,
        ...info
      };
    }

    const postData = {
      id: bookingId,
      gatewayId: methodId,
      methodId,
      paymentTypeDetail: code,
      groupId: 4,
      platform: platformType === "desktop" ? "pc" : "web",
      ...paramsVisa
    };
    console.log("postData", postData);

    const urlCallBack =
      size(totalData.schedulesSelected) > 1
        ? `${currentEnv.MEDPRO_WEB}/transactions/${totalData.paymentInformation[0].bookingInfo.transactionId}`
        : `${currentEnv.MEDPRO_WEB}/booking/${totalData.paymentInformation[0].smsCode}`;
    postData.redirectUrl = urlCallBack;

    console.log("postData :>> ", postData);
    const response = yield api.reserveRePayment(
      getBaseUrl() + `${BOOKING.RESERVE_NO_AUTHEN}`,
      postData
    );
    const { data } = response;

    yield put({
      type: types.RESERVE_BOOKING_SUCCESS,
      payload: data
    });

    if (data.isGateway === 1) {
      data?.qrCodeUrl && (window.location.href = data?.qrCodeUrl);
    }
    const smsCode = data?.smsCode
      ? data?.smsCode
      : totalData?.paymentInformation?.[0]?.smsCode;
    if (data.isGateway === 0) {
      data?.redirectUrl
        ? (window.location.href = data?.redirectUrl)
        : history.push(`/booking/${smsCode}`);
    }
  } catch (error) {
    console.log("error requestReserveBookingRePayment :>> ", error);

    const { statusCode, message } = get(error, "response.data", "");
    openToast(message, "error");
    if (statusCode === 401) {
      handleUnAuthorize();
    }
    yield put({
      type: types.RESERVE_BOOKING_FAILURE
    });
  }
}

function* requestReserveBookingWatcher() {
  yield takeLatest(types.RESERVE_BOOKING, requestReserveBooking);
}

// Repayment Booking
function* requestRepaymentBooking() {
  try {
    const global = yield select(state => state.global);
    const platformType = get(global, "device.type");
    const platform = platformType === "desktop" ? "pc" : "web";
    const partnerid = yield select(state => state.totalData.partnerId);

    const {
      selectedMethod: { code }
    } = yield select(state => state.payment);

    const totalData = yield select(state => state.totalData);
    const bookingId = get(totalData, "paymentInformation[0].bookingInfo.id");

    console.log("bookingId :>> ", bookingId);

    const redirectUrl = ``;

    const postData = {
      methodId: code,
      paymentTypeDetail: code,
      redirectUrl: redirectUrl,
      id: bookingId,
      groupId: 4
    };

    console.log("postData :>> ", postData);

    // const response = yield client.rePayment(postData, {
    //   partnerid,
    //   appid: AppId,
    //   platform
    // });
    // const { data } = response;

    // yield put({
    //   type: types.RESERVE_BOOKING_SUCCESS,
    //   payload: data
    // });

    // if (size(totalData.schedulesSelected) > 1) {
    //   history.push(
    //     `/chi-tiet-phieu-kham-benh?mpTransaction=${data.transactionId}`
    //   );
    // } else {
    //   history.push(
    //     `/chi-tiet-phieu-kham-benh?mpTransaction=${data.transactionId}`
    //   );
    // }

    // if (data.isGateway === 1) {
    //   yield put({
    //     type: types.RESERVE_BOOKING_SUCCESS,
    //     payload: data
    //   });

    //   // Đá theo qrCodeUrl đc trả về
    //   data.qrCodeUrl && (window.location.href = data.qrCodeUrl);
    // } else if (data.isGateway === 0) {
    //   history.push(
    //     `/chi-tiet-phieu-kham-benh?mpTransaction=${data.transactionId}`
    //   );

    //   yield put({
    //     type: types.GET_PAYMENT_INFO_SUCCESS,
    //     payload: response.data
    //   });
    // }
  } catch (error) {
    console.log("error requestRepaymentBooking :>> ", error);

    // const message = get(error, "response.data.message", "");
    // openToast(message, "error");
    // yield put({
    //   type: types.RESERVE_BOOKING_FAILURE
    // });
  }
}

function* requestRepaymentBookingWatcher() {
  yield takeLatest(types.REPAYMENT_BOOKING, requestRepaymentBooking);
}

// Payment Info
function* requestPaymentInfo(action) {
  const global = yield select(state => state.global);
  const platformType = get(global, "device.type");
  const platform = platformType === "desktop" ? "pc" : "web";
  const transactionId = get(action, "payload", "");
  try {
    const partnerid = yield select(state => state.totalData.partnerId);
    const typePayment = get(action, "typePayment");
    const postData = {
      transactionId,
      type: typePayment
    };
    const response = yield client.getPaymentInfo(postData, {
      partnerid,
      platform
    });

    yield put({
      type: types.GET_PAYMENT_INFO_SUCCESS,
      payload: response.data
    });
  } catch (error) {
    console.log("error requestPaymentInfo :>> ", error);
    const text = get(action, "text", "");
    if (text === "payment") {
      openToast("Thanh toán không thành công!", "error");
    } else {
      openToast("Có lỗi xảy ra, vui lòng thử lại!", "error");
      // history.push("/user");
    }
  } finally {
    yield put(notiAction.getNotificationOnPage({ category: 1 }));
    window.localStorage.setItem("transId", JSON.stringify(transactionId));
  }
}

function* requestPaymentInfoWatch() {
  yield takeLatest(types.GET_PAYMENT_INFO, requestPaymentInfo);
}

function* requestBookingInfo({ payload }) {
  const { transactionId, text } = payload;

  try {
    const global = yield select(state => state.global);
    const platformType = get(global, "device.type");
    const platform = platformType === "desktop" ? "pc" : "web";
    const partnerid = yield select(state => state.totalData.partnerId);

    const postData = {
      transactionId
    };

    const response = yield client.getBookingWithTransactionCode(postData, {
      partnerid,
      platform
    });

    const editData = isArray(response.data) ? response.data : [response.data];

    yield put({
      type: types.GET_PAYMENT_INFO_SUCCESS,
      payload: editData
    });

    // const patient = get(response, "data.patientInfo");

    // yield put(patientActions.selectPatientFromData(patient));
  } catch (error) {
    if (text === "payment") {
      openToast("Thanh toán không thành công!", "error");
    } else {
      const message = get(error, "response.data.message");
      openToast(message, "error");
      history.push("/user");
    }
  } finally {
    yield put(notiAction.getNotificationOnPage({ category: 1 }));
  }
}

function* watchRequestBookingInfo() {
  yield takeLatest(types.GET_BOOKING_INFO, requestBookingInfo);
}

// Medicall Bill
function* requestAllMedicalBill() {
  try {
    const global = yield select(state => state.global);
    const platformType = get(global, "device.type");
    const platform = platformType === "desktop" ? "pc" : "web";
    const partnerid = yield select(state => state.totalData.partnerId);
    const response = yield client.getAllBookingByUserId({
      partnerid,
      appid: AppId,
      platform
    });
    yield put({
      type: types.GET_ALL_MEDICAL_BILLS_SUCCESS,
      payload: response.data
    });
  } catch (error) {
    console.log(error);
    const errorCode = get(error, "response.data.statusCode", 0);
    if (errorCode === 401) {
      history.push("/");
    }
    yield put({
      type: types.GET_ALL_MEDICAL_BILLS_FAILURE
    });
  }
}

function* watchRequestAllMedicalBill() {
  yield takeLatest(types.GET_ALL_MEDICAL_BILLS, requestAllMedicalBill);
}

// auto next step
function* requestChangeStepAuto({ payload }) {
  const partnerId = yield select(state => state.totalData.partnerId);

  const {
    type,
    subType,
    child,
    // detail: { nextCombine, serviceType },
    dynamic,
    pickType,
    end
  } = payload;

  // console.log("----------------------------------------- :>> ");
  // console.log("type :>> ", type);
  // console.log("payload :>> ", payload);

  if (pickType === "LATER") {
    yield put({ type: types.SET_SCHEDULE_WITHOUT_DATE, payload: true });
    yield put({ type: types.ADD_SCHEDULE });
    history.push("/chon-ho-so");
  } else if (dynamic) {
    yield put({ type: types.GET_SUB_BOOKING_TREE });
  } else {
    // const checkBH = serviceType === SERVICE_TYPE_BOTH;
    const nextRoute = getStepFollowTreeMap(subType, partnerId);

    // nếu phần tử đầu tiên bước tiếp theo > 1 thì đi
    if (size(child) > 1) {
      history.push(nextRoute);
    }
    // nếu phần tử đầu tiên bước tiếp theo === 1 thì thực hiện auto skip
    else if (size(child) === 1) {
      // nếu không có subtype thì tới chọn lịch khám
      if (!subType) {
        history.push(nextRoute);
      }
      // ngược lại thì kiểm tra skip
      else {
        //  nếu bước kế tiếp là dịch vụ
        if (subType === "service") {
          const addonServices = get(child[0], "detail.addonServices", []);
          const popupType = get(child[0], "detail.popupType", 0);
          // nếu phần tử đầu tiên của dịch vụ : vừa có tiền vừa khám bhyt -> đi tới chọn dịch vụ
          if (first(child).detail.serviceType === SERVICE_TYPE_BOTH) {
            history.push(nextRoute);
          } else if (addonServices.length > 1 && popupType === 1) {
            // Case này lưu ý review lại có cần thiết không
            history.push(nextRoute);
          }
          // nếu phần tử đầu tiên của dịch vụ có dịch vụ cộng thêm > 1 và có ghi nhận cam kết bảo hiểm -> đi tới chọn dịch vụ
          else if (addonServices.length > 0) {
            history.push(nextRoute);
          }
          // ngược lại thì auto skip
          else {
            yield put({
              type: nodeAction[subType].typeSelect,
              payload: first(child)
            });
          }
        }
        // bước kế tiếp là dịch vụ thì auto skip
        else {
          yield put({
            type: nodeAction[subType].typeSelect,
            payload: first(child)
          });
        }
      }
    }

    // nếu phần tử đầu tiên < 1
    else if (size(child) < 1) {
      //  nếu giá trị end ở bước hiện tại là true thì kết thúc tree --> tới bước tiếp theo
      if (end) {
        history.push(nextRoute);
      }
    }
  }
}

function* watchRequestChangeStepAuto() {
  yield takeLatest(types.SELECT_SUBJECT, requestChangeStepAuto);
  yield takeLatest(types.SELECT_SERVICE, requestChangeStepAuto);
  yield takeLatest(types.SELECT_DOCTOR, requestChangeStepAuto);
  yield takeLatest(types.SELECT_ROOM, requestChangeStepAuto);
}

// back action
function* requestGoBack({ node }) {
  const partnerId = yield select(state => state.totalData.partnerId);
  const listNode = yield select(state => state.totalData.listNode);
  const typeAction = yield select(state => state.totalData.typeAction);
  const index = listNode.findIndex(item => item === node);
  const serviceTypeDefault = yield select(
    state => state.totalData.service.serviceTypeDefault
  );

  /**
   * index === 0 --> node đầu tiên --> kiểm tra AppId -->
   *     medpro || momo --> kiểm tra list feature
   *           length = 1  --> chọn bệnh viện
   *           length > 1  --> chọn feature
   *     bệnh viện  --> home
   * index > 0 --> kiểm tra list parent
   *     length = 1  --> gọi lại function này
   *     length > 1  --> redirect về node cha
   */
  if (index === 0) {
    if (AppId === "medpro" || AppId === "momo") {
      const listFeature = yield select(
        state => state.features.allFeatures.list
      );
      if (listFeature.length === 1) {
        if (history && history.length > 1) {
          history.goBack();
        } else {
          history.push("/chon-benh-vien");
        }
      } else {
        if (history && history.length > 1) {
          history.goBack();
        } else {
          const url = getRouteFollowPartnerId(
            "/chon-hinh-thuc-dat-kham",
            partnerId
          );
          history.push(url);
        }
      }
    } else {
      if (history && history.length > 1) {
        history.goBack();
      } else {
        const urlBookingType = getRouteFollowPartnerId(
          "/chon-hinh-thuc-dat-kham",
          partnerId
        );
        history.push(urlBookingType);
      }
    }
  } else {
    const parentName =
      index === -1 ? listNode[listNode.length - 1] : listNode[index - 1];

    const parentNode = yield select(state => state.totalData[parentName]);

    /**
     * Nếu update booking + bước trước là dịch vụ thì về home luôn. (K cho update dịch vụ)
     */
    if (
      typeAction === TypeAction.SuaPhieuKham &&
      parentNode?.type === "service" &&
      partnerId !== "nhidong1" // update v2. nhidong1 không thay đổi.
    ) {
      history.push("/");
      return;
    }

    const url = getStepFollowTreeMap(parentNode.type, partnerId);

    if (parentNode.list.length > 1) {
      if (history && history.length > 1) {
        history.goBack();
      } else {
        history.push(url);
      }
    } else {
      if (parentNode.type === "service") {
        if (serviceTypeDefault === SERVICE_TYPE_BOTH) {
          if (history && history.length > 1) {
            history.goBack();
          } else {
            history.push(url);
          }
        } else {
          yield put({ type: types.GO_BACK_STEP, node: parentName });
        }
      } else {
        yield put({ type: types.GO_BACK_STEP, node: parentName });
      }
    }
  }
}

function* watchRequestGoBack() {
  yield takeLatest(types.GO_BACK_STEP, requestGoBack);
}

// reset list node
function* resetListNode({ payload }) {
  /**
   * So sánh node với list node
   * Reset toàn bộ các node phía sau
   * Reset ngày tháng: case chọn BH --> tôi không có BH
   */

  // Reset ngày giờ
  yield put({ type: types.RESET_SELECT_DATE });
  yield put({ type: types.RESET_SELECT_TIME_SLOT });

  let listNode = yield select(state => state.totalData.listNode);
  const index = listNode.findIndex(item => item === payload);
  if (index === 0) {
    // reset all
    for (const item of Object.keys(nodeAction)) {
      yield put({ type: nodeAction[item].typeReset });
    }
  } else {
    listNode = listNode.slice(listNode.findIndex(item => item === payload));
    for (const item of listNode) {
      yield put({ type: nodeAction[item].typeReset });
    }
  }
}

function* watchResetListNode() {
  yield takeLatest(types.RESET_LIST_NODE, resetListNode);
}

// Reserve Booking Partner
function* requestReserveBookingPartner() {
  try {
    // call list payment method --> get amount
    yield put({
      type: paymentTypes.GET_ALL_PAYMENT_METHODS
    });
    const listPaymentMethod = yield select(state => state.payment.data);
    const momoMethod = listPaymentMethod.find(item => item.methodId === "momo");

    // select method MOMO
    yield put({
      type: paymentTypes.SELECTED_PAYMENT_METHOD,
      method: momoMethod.paymentTypes[0],
      methodId: momoMethod.methodId
    });

    // call reserve booking
    yield put({
      type: types.RESERVE_BOOKING
    });
  } catch (error) {
    console.log("error requestReserveBookingPartner :>> ", error);
  }
}

function* watchReserveBookingPartner() {
  yield takeLatest(types.RESERVE_PAYMENT_PARTNER, requestReserveBookingPartner);
}

function* uploadFile({ file }) {
  try {
    const formData = new FormData();

    formData.append("File", file);

    yield client.uploadFile(formData);

    // yield put({
    //   type: types.GET_ALL_HIDDEN_MEDICAL_BILLS_SUCCESS,
    //   payload: response.data
    // });
  } catch (error) {
    huyi({ name: "error-uploadFile", child: error, type: 0 });

    const errorCode = get(error, "response.data.statusCode", 0);
    if (errorCode === 401) {
      history.push("/");
    }
  }
}

function* watchUploadFile() {
  yield takeLatest(types.UPLOAD_FILE, uploadFile);
}

// getExtraConfig
function* requestExtraConfig({ partnerId }) {
  try {
    const global = yield select(state => state.global);
    const platformType = get(global, "device.type");
    const platform = platformType === "desktop" ? "pc" : "web";

    const partnerid = yield partnerId ||
      select(state => state.totalData.partnerId);
    const response = yield client.getExtraConfig({ partnerid });

    yield put({
      type: types.GET_EXTRA_CONFIG_SUCCESS,
      payload: response.data
    });
  } catch (error) {
    huyi({ name: "error-requestExtraConfig", child: error, type: 0 });
  }
}

function* requestExtraConfigWatcher() {
  yield takeEvery(types.GET_EXTRA_CONFIG, requestExtraConfig);
}

function* requestReserveMutipleBookings({ referralCode }) {
  try {
    const token = yield select(state => state.user.info.token);
    const totalDataReducer = yield select(state => state.totalData);
    const globalReducer = yield select(state => state.global);
    const paymentMethodReducer = yield select(state => state.payment);
    const patientReducer = yield select(state => state.patient);
    const reExamReducer = yield select(state => state.followUpExam);
    const { cskhToken } = yield select(state => state.customerService);
    const partnerid = get(totalDataReducer, "partnerId");
    const platformType = get(globalReducer, "device.type");
    const platform = platformType === "desktop" ? "pc" : "web";

    const postData = convertDataToMutipleBookings(
      totalDataReducer,
      globalReducer,
      paymentMethodReducer,
      patientReducer,
      reExamReducer
    );
    postData.redirectUrl = `${window.location.origin}/cskh/booking`;

    // Thêm referralCode vào postData nếu có
    if (referralCode && referralCode.trim() !== "") {
      postData.referralCode = referralCode.trim();
    }

    const response = yield client.reserveMultipleBookings(postData, {
      partnerid,
      appid: AppId,
      token,
      platform,
      cskhtoken: cskhToken
    });
    const { data } = response;

    yield put({
      type: types.RESERVE_BOOKING_SUCCESS,
      payload: data
    });

    if (data.transactionId) {
      history.push(`/cskh/booking?transactions=${data.transactionId}`);
    }
  } catch (error) {
    huyi({
      name: "client.reserveMultipleBookings",
      child: error,
      type: "error"
    });
    const { statusCode, message } = get(error, "response.data", "");
    openToast(message, "error");
    if (statusCode === 401) {
      handleUnAuthorize();
    }
    yield put({
      type: types.RESERVE_BOOKING_FAILURE
    });
  }
}

function* requestReserveMutipleBookingsWatcher() {
  yield takeLatest(
    types.RESERVE_MULTIPLE_BOOKINGS,
    requestReserveMutipleBookings
  );
}

function* requestReserveBookingCare247({ payload }) {
  try {
    const response = yield client.reserveMedproCareCskh(payload);
    const { data } = response;
    if (data.transactionId) {
      window.location.href = data.qrCodeUrl;
    }
  } catch (err) {
    console.log("err reserveMedproCare", err);
  }
}

function* watchReserveBookingCare247() {
  yield takeLatest(
    types.RESERVE_BOOKING_CARE_247,
    requestReserveBookingCare247
  );
}

function* requestReserveBookingAddonCare247({ payload }) {
  try {
    const response = yield client.reserveMedproCareAddonCskh(payload);
    const { data } = response;
    if (data.transactionId) {
      window.location.href = data.qrCodeUrl;
    }
  } catch (err) {
    console.log("err reserveMedproCare", err);
  }
}

function* watchRequestReserveBookingAddonCare247() {
  yield takeLatest(
    types.RESERVE_BOOKING_ADDON_CARE_247,
    requestReserveBookingAddonCare247
  );
}

export default function* root() {
  yield all([
    fork(requestReserveMutipleBookingsWatcher),
    fork(requestExtraConfigWatcher),
    fork(watchUploadFile),
    fork(requestBookingTreeWatcher),
    fork(requestReserveBookingWatcher),
    fork(requestRepaymentBookingWatcher),
    fork(requestPaymentInfoWatch),
    fork(watchRequestBookingInfo),
    fork(watchRequestAllMedicalBill),
    fork(watchRequestChangeStepAuto),
    fork(requestSubBookingTreeWatcher),
    fork(watchResetListNode),
    fork(watchReserveBookingPartner),
    fork(watchRequestGoBack),
    fork(watchReserveBookingCare247),
    fork(watchRequestReserveBookingAddonCare247),
    yield takeLatest(
      types.RESERVE_BOOKING_REPAYMENT,
      requestReserveBookingRePayment
    )
  ]);
}
